import { render } from "./productSlider.vue?vue&type=template&id=028bcf1d"
import script from "./productSlider.vue?vue&type=script&lang=js"
export * from "./productSlider.vue?vue&type=script&lang=js"

import "./productSlider.vue?vue&type=style&index=0&id=028bcf1d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__